import Skeleton, { SkeletonCard } from './Skeleton';

/**
 * Suspense fallback rendered while a lazy-loaded route chunk is being fetched.
 * Kept lightweight so it lives in the main bundle alongside Router.
 */
export default function RouteFallback() {
  return (
    <div>
      <Skeleton width={160} height={14} style={{ marginBottom: 18 }} />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 12,
          marginBottom: 20,
        }}
      >
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
      <SkeletonCard height={260} />
    </div>
  );
}
